/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CameraOnIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function CameraOnIcon({
  children,
  viewPath = "/DesignSystem/Svgs/CameraOnIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 32,
  height = 32,
  fill = "none",
  stroke = "#000"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="CameraOnIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 32 32"
 style={{'--as-1-Z13iVSG': alignSelf,'--mt-2-Z13iVSG': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z13iVSG': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z13iVSG': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z13iVSG': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z13iVSG': opacity,'--w-7-Z13iVSG': typeof width === 'number' ? `${width}px` : width,'--h-8-Z13iVSG': typeof height === 'number' ? `${height}px` : height}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="CameraOnIcon.SvgPath"
  data-view-path={viewPath}
 strokeWidth={2}
 strokeLinecap="round"
 strokeLinejoin="round"
 strokeMiterlimit={10}
 d="M20 23.4H6.9c-1.4 0-2.6-1.2-2.6-2.6v-9.7c0-1.4 1.2-2.6 2.6-2.6H20c1.4 0 2.6 1.2 2.6 2.6v9.7c-.2 1.5-1.4 2.6-2.6 2.6z"
 style={{'--f-9-Z13iVSG': fill,'--s-10-Z13iVSG': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
<path
  data-testid="CameraOnIcon.SvgPath:1"
  data-view-path={viewPath}
 strokeWidth={2}
 strokeLinejoin="round"
 strokeMiterlimit={10}
 d="M22.4 13.8l5.2-5.2v13.7L22.4 17"
 style={{'--f-9-Z13iVSG': fill,'--s-10-Z13iVSG': stroke}}
 className={`views-block ${styles.SvgPath1}`}
/>
</svg>
{children}
</React.Fragment>)
}